"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZoomWindow = void 0;
const Utilities_1 = require("../../../javascript/Utilities");
const ExternalInput_1 = require("./ExternalInput");
const Base_1 = require("../../../model/Base");
/**
* Text zoom (cefunc.173)
*/
class ZoomWindow extends ExternalInput_1.ExternalInput {
    constructor(controlColl, currentInstance, methodName) {
        super(controlColl, currentInstance, methodName);
        this.methodName = methodName;
        this.windowMinWidth = 500;
        this.windowMinHeight = 345;
        this.windowWidth = $(window).width() - 50;
        this.windowHeight = $(window).height() - 80;
        this.windowContentCssClass = "eiZoomWindow";
        this.windowActions = ["Maximize", "Close"];
        this.needServerConfig = true;
    }
    getUpdatedInstance() {
        let updatedInstance = this.currentInstance;
        updatedInstance.items[this.input.field.fieldName].value = this.textArea.val();
        return Promise.resolve(updatedInstance);
    }
    initWindowContents() {
        let that = this;
        let phone = Utilities_1.synUtil.clientDeviceClass === "phone";
        let tablet = Utilities_1.synUtil.clientDeviceClass === "tablet";
        let resizeTextbox = function (that) {
            let $windowContent = $("#" + that.windowId);
            that.textArea.css("height", ($windowContent.innerHeight() - 20) + "px");
        };
        that.textArea = $("<textarea class='zoomTextArea k-textbox' id='textArea_" + that.windowData.guid + "'></textarea>")
            .appendTo(that.widgetContainer);
        let heightOffset = 0;
        if (Utilities_1.synUtil.clientDeviceClass === 'phone')
            heightOffset = 70;
        if (that.serverConfig.fontsize)
            that.textArea.css("font-size", that.serverConfig.fontsize + "px");
        that.widgetContainer.css("height", that.windowData.contentDiv.innerHeight() - heightOffset + "px");
        that.textArea
            .val(that.currentInstance.items[that.input.field.fieldName].value)
            .focus();
        if (that.mode === Base_1.PropertyPageMode.View)
            that.textArea.attr("readonly", "readonly");
        let dialog = that.windowData.windowDiv.data("kendoWindow");
        if (phone || tablet)
            dialog.setOptions({
                resizable: false,
            });
        else
            dialog.setOptions({
                resizable: true,
                minWidth: that.windowMinWidth == undefined ? that.windowWidth : that.windowMinWidth,
                minHeight: that.windowMinHeight == undefined ? that.windowHeight : that.windowMinHeight
            });
        resizeTextbox(that);
        dialog.bind("resize", function (e) {
            resizeTextbox(that);
        });
        return Promise.resolve();
    }
}
exports.ZoomWindow = ZoomWindow;
